<template>
    <div class="relative">
        <div @click="open = !open"
            class="flex p-2 -mb-2 rounded-t cursor-default text-logo-dark hover:text-white hover:bg-logo-dark"
            :class="{ 'text-white bg-logo-dark rounded-t ': open }">
            <slot name="trigger"></slot>
            <svg v-if="caret" class="w-5 h-5 pt-1 ml-0 -mr-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd" />
            </svg>
        </div>

        <!-- Full Screen Dropdown Overlay -->
        <div id="menuCloak" v-show="open" class="fixed inset-0 z-40 bg-gray-700 bg-opacity-25" @click="open = false">
        </div>

        <transition enter-active-class="transition duration-200 ease-out" enter-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100" leave-active-class="transition duration-75 ease-in"
            leave-class="transform scale-100 opacity-100" leave-to-class="transform scale-95 opacity-0">
            <div v-show="open"
                class="min-w-[75px] absolute z-50 mt-2 overflow-y-auto rounded-b-lg shadow-lg max-h-screen-50"
                :class="[widthClass, alignmentClasses]" style="display: none;">
                <!-- <div class="rounded-b-lg shadow-xs" :class="contentClasses"> -->
                <div class="shadow-xs" :class="contentClasses">
                    <slot name="content" v-bind:closed="close"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        align: {
            default: 'right'
        },
        width: {
            default: 'full'
        },
        contentClasses: {
            default: () => ['bg-white']
        },
        caret: {
            default: true
        },
    },

    data() {
        return {
            open: false
        }
    },

    created() {
        const closeOnEscape = (e) => {
            if (this.open && e.keyCode === 27) {
                this.open = false
            }
        }

        this.$once('hook:destroyed', () => {
            document.removeEventListener('keydown', closeOnEscape)
        })

        document.addEventListener('keydown', closeOnEscape)
    },

    computed: {
        widthClass() {

            // can't do this because TW JIT compiler
            // return 'w-' + this.width;

            return {
                '20': 'w-20',
                '48': 'w-48',
                '96': 'w-96',
                '500px': 'w-[500px]',
                'full': 'w-full',
            }[this.width.toString()]
        },

        alignmentClasses() {
            if (this.align === 'left') {
                return 'origin-top-left left-0'
            } else if (this.align === 'right') {
                return 'origin-top-right right-0'
            } else {
                return 'origin-top'
            }
        },
    },
    methods: {
        close() {
            this.open = false;
        }
    }
}
</script>
